import { Site } from '@superbet-group/web.types';
import { Location } from 'vue-router';

export type RouteIdentity<Value> = Required<{
    App: {
        Home: Value;
        Info: Value;
        Wiki: Value;
        NotFound: Value;
        NotAuthorized: Value;
        CatchAll: Value;
        TermsAndConditions?: Value;
        Shops?: Value;
        IdCardVerificationCaptive?: Value;
        VerifyPhoneCaptive?: Value;
        BrMigrationComplete?: Value;
    };
    Account: {
        PaymentGatewayStatus: Value;
        Profile: Value;
        PasswordRecovery: Value;
        ForgotPassword: Value;
        Register: Value;
        ResendActivationEmail: Value;
        ContinueRegistration: Value;
        Deposit: Value;
        History: Value;
        Settings: Value;
        Withdrawal: Value;
        DocumentUpload: Value;
        IdentityVerification: Value;
        IdentityVerificationUploadAdditional: Value;
        ResponsibleGaming: Value;
        DepositLimit: Value;
        BettingLimit: Value;
        LossLimit: Value;
        SessionLimit: Value;
        SelfExclusion: Value;
        TimeOut: Value;
        AccountClosure: Value;
        RealityCheck: Value;
        MyMessages: Value;
        Container: Value;
        Recovery: Value;
        Activate: Value;
        ChangePhone: Value;
        ReferAFriend: Value;
        HelpAndSupport: Value;
        ChatPlaceholder: Value;
        MySocial: Value;
        EditMySocial: Value;
        BlockedUsers: Value;
        MyAccount: Value;
        ChangePassword: Value;
        SettingsBetslip: Value;
        SwitchLanguage: Value;
        SwitchTheme: Value;
        LicencePreferences: Value;
        LoginHistory: Value;
        AccountSecurity: Value;
    };
    Sport: {
        OfferEvent: Value;
        BetSlip: Value;
        Category: Value;
        CategoryPerTime: Value;
        CategoryRedirect: Value;
        SportCompetitions: Value,
        Competition: Value;
        EventRedirect: Value;
        Favourites: Value;
        Filter: Value;
        Search: Value;
        PrematchOffer: Value;
        TournamentRedirect: Value;
        SuperAdvantage: Value;
        PriceBoost: Value;
        MultiEventBetBuilder: Value;
        PopularBets: Value;
        TopWinners: Value;
        Social: Value;
    };
    Lottery: {
        Offer: Value;
    };
    News: {
        Article: Value;
        Articles: Value;
        Feed: Value;
    };
    Free2Play: {
        BingoBash: Value;
        SuperSpin: Value;
        FreeGamesInfo: Value;
        SportCaller: Value;
        SuperMillion: Value;
        CalendarGame: Value;
        SuperShot: Value;
        TopManager: Value;
        FantasticDuels: Value;
    };
    GrowthMarketing: {
        LandingIntro: Value;
        PromotionsInfo: Value;
        NewBettingSiteSerbia?: Value;
    };
    Native: {
        AppsFooter: Value;
        Wiki: Value;
    };
    BonusAndComms: {
        LpBonus: Value;
        PromotionHub: Value;
        Notifications: Value;
        MarketingConsent: Value;
    };
    Loyalty: {
        Supercoins: Value;
    }
}>;

export type Product = {
    Account: {
        ResponsibleGaming: boolean;
        MyMessages: boolean;
        ChangePhone: boolean;
        HelpAndSupport: boolean;
        MyAccount: boolean;
        ChangePassword: boolean;
        SwitchLanguage: boolean;
        LicencePreferences: boolean;
        LoginHistory: boolean;
    };
    Sport: boolean;
    Lottery: boolean;
    News: boolean;
    Free2Play: {
        BingoBash: boolean;
        SuperSpin: boolean;
        FreeGamesInfo: boolean;
        SportCaller: boolean;
        SuperMillion: boolean;
        CalendarGame: boolean;
        SuperShot: boolean;
        TopManager: boolean;
        FantasticDuels: boolean;
    };
    GrowthMarketing: {
        NewBettingSiteSerbia: boolean;
    };
    BonusAndComms: {
        LpBonus: boolean;
        Notifications: boolean;
    };
    Loyalty: {
        Supercoins: boolean;
    };
    Games: boolean;
    CasinoLive: boolean;
    Virtual: boolean;
    Shops: boolean;
};

export const NavigationItem = {
    Logo: 'Logo',
    Sport: 'Sport',
    Casino: 'Casino',
    CasinoLive: 'CasinoLive',
    CasinoLiveCategory: 'CasinoLiveCategory',
    Results: 'Results',
    News: 'News',
    Shops: 'Shops',
    Lottery: 'Lottery',
    Bingo: 'Bingo',
    Virtual: 'Virtual',
    Live: 'Live',
    Social: 'Social',
    Promotions: 'Promotions',
    CardGames: 'CardGames',
    VerifyTicket: 'VerifyTicket',
    Help: 'Help',
    PromotionHub: 'PromotionHub',
    MyTickets: 'MyTickets',
    SportPrematch: 'SportPrematch',
} as const;
export type NavigationItem = typeof NavigationItem[keyof typeof NavigationItem];

export type NavigationDestination = SingleDomainDestination | MultipleDomainDestination;

export const NavigationKind = {
    SingleDomain: 'SingleDomain',
    MultipleDomain: 'MultipleDomain',
} as const;
export type NavigationKind = typeof NavigationKind[keyof typeof NavigationKind];

export type SingleDomainDestination = {
    kind: typeof NavigationKind.SingleDomain;
    location: Location;
};

export type MultipleDomainDestination = {
    kind: typeof NavigationKind.MultipleDomain;
    location: Location;
    site: Site;
    path?: string;
};
